<template>

  <div>
    <div>

      <template v-if="reservationType === 'acc' || reservationType === 'request'">
        <div class="field-name">Alege data</div>
        <div class="input-box">
          <img src="/v2/images/calendar-reserv.png" style="margin-top:2px;height:30px;">
          <div class="calendar-date-select">
            <DatePicker format="dd/MM/yyyy" :language="ro" input-class="form-control hand"  v-model="form.departure_date" />
          </div>
        </div>

        <div class="field-name">Alege numarul de nopti</div>
        <div class="input-box">
          <img src="/v2/images/nr-of-nights.png" style="margin-top:2px;height:30px;">
          <div class="select-number-nights">
            <select name="nights" class="form-control" v-model="form.nights">

              <template v-for="night in 21">
                <option  v-if="night > 2" v-bind:key="night" :value="night">
                  {{night}} nopti
                </option>
              </template>

            </select>
          </div>
        </div>
      </template>
      <template v-if="reservationType === 'request'">
        <div class="field-name">Alege tipul de masa</div>
        <div class="input-box">
          <img src="/v2/images/utensils-solid.svg" style="margin-top:2px;height:30px;">
          <div class="select-number-nights">
            <select name="nights" class="form-control" v-model="form.meal">

              <option value="">Masa</option>
              <option>Fara masa</option>
              <option>Mic dejun</option>
              <option>Demipensiune</option>
              <option>Pensiune completa</option>
              <option>All inclusive</option>

            </select>
          </div>
        </div>

        <div class="field-name">Transport</div>
        <div class="input-box">
          <img src="/v2/images/plane-solid.svg" style="margin-top:2px;height:30px;fill: #c6c6c6">
          <div class="select-number-nights">
            <select name="nights" class="form-control" v-model="form.transport">

              <option value="">Transport</option>
              <option>Individual</option>
              <option>Avion</option>

            </select>
          </div>
        </div>
      </template>

    </div>

    <div class="reservation-title mt-5">Detalii camere</div>
    <div class="field-name">Numar camere</div>
    <div class="input-box">
      <img src="/v2/images/bed-alt-regular.svg">
      <div class="room-number">
        <a  class="btn minus-btn" @click="decreaseRooms()"><i class="fas fa-minus"></i></a>
        {{rooms.length}}
        <a  class="btn plus-btn" @click="increaseRooms()"><i class="fas fa-plus"></i></a>
      </div>
    </div>

    <div v-for="(room, i ) in rooms" v-bind:key="i" class="room">
      <div class="field-name">In camera {{i+1}} vor fi</div>
      <div class="room-container">
        <div class="input-box-top">
          <span class="room-ocupant">Adulti</span>
          <div class="room-number">
            <a  class="btn minus-btn" @click="decreaseAdults(i)"><i class="fas fa-minus"></i></a>
            {{room.adults}}
            <a  class="btn plus-btn" @click="increaseAdults(i)"><i class="fas fa-plus" ></i></a>
          </div>
        </div>
        <div class="input-box-middle">
          <span class="room-ocupant">Copii</span>
          <div class="room-number">
            <a  class="btn minus-btn" @click="decreaseKids(i)"><i class="fas fa-minus"></i></a>
            {{room.kids.length}}
            <a  class="btn plus-btn"  @click="increaseKids(i)"><i class="fas fa-plus"></i></a>
          </div>
        </div>
        <div class="input-box-bottom" v-if="room.kids.length > 0">
          <span class="room-ocupant">Varsta copii</span>
          <div class="room-number room-number-select-age">
            <select  v-for="(kid, iKids) in room.kids" v-bind:key="iKids" v-model="room.kids[iKids].age" class="select-kid-age form-control custom-select-2">
              <option :value="0" :selected="true">Sub 1 an</option>
              <option v-for="age in 18" :value="age" v-bind:key="age">
                {{age + ( age > 1 ? ' ani' : ' an' )}}             </option>

            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="reservation-title mt-5">Informatii personale</div>
    <div class="field-name">Nume si prenume</div>

      <label class="sr-only" >Nume</label>
      <div class="input-group reserv-input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fas fa-user"></i></div>
        </div>
        <input type="text" class="form-control reserv-form-control"  placeholder="Nume complet" v-model="form.name">
      </div>


    <div class="field-name">Email</div>

      <label class="sr-only">Email</label>
      <div class="input-group reserv-input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fas fa-envelope"></i></div>
        </div>
        <input type="text" class="form-control reserv-form-control"  placeholder="Email" v-model="form.email">
      </div>

    <div class="field-name">Telefon</div>

      <label class="sr-only" >Telefon</label>
      <div class="input-group reserv-input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fas fa-phone"></i></div>
        </div>
        <input type="text" class="form-control reserv-form-control" placeholder="Telefon" v-model="form.phone">
      </div>

    <div class="field-name">Mesaj</div>

      <div class="input-group reserv-input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fas fa-pen"></i></div>
        </div>
        <textarea class="form-control reserv-form-control" rows="4" v-model="form.message"></textarea>
      </div>

    <a @click="sendReservationForm()" class="btn reserv-send-request" style="color:#ffffff">Trimite solicitarea</a>
  </div>
</template>

<script>
  import DatePicker from 'vuejs-datepicker';
  import {ro} from 'vuejs-datepicker/dist/locale';
  import axios from 'axios';
  /* global reservationType */
  /* global startDate */
  /* global ofrRefId */
export default {
  name: 'Index',
  data(){

    return {
      reservationType: '',
      showCheckIn: true,
      ro: ro,
      rooms: [],
      form: {
        name: '',
        email:  '',
        phone: '',
        message: '',
        departure_date: '',
        nights: 7,
        meal: '',
        transport: ''

      }
    }
  },
  components: {
    DatePicker
  },
  methods: {

    increaseRooms(){

      if(this.rooms.length < 4){

        this.pushRoom();
      }
    },
    decreaseRooms(){

      if(this.rooms.length > 1){

        this.rooms.pop();
      }
    },
    increaseAdults(roomIndex){

      if(this.rooms[roomIndex].adults < 5){

        this.rooms[roomIndex].adults++;
      }
    },
    decreaseAdults(roomIndex){

      if(this.rooms[roomIndex].adults > 1){

        this.rooms[roomIndex].adults--;
      }
    },
    increaseKids(roomIndex){
      if(this.rooms[roomIndex].kids.length < 4){

        this.rooms[roomIndex].kids.push({age: 0});
      }
    },
    decreaseKids(roomIndex){
      if(this.rooms[roomIndex].kids.length > 0){

        this.rooms[roomIndex].kids.pop();
      }
    },
    pushRoom(){

      this.rooms.push({'adults' : 2, kids: [] });
    },
    sendReservationForm(){
      console.log(this.extra);
      let postParams = {
        rooms: this.rooms,
        form: this.form,
        type: reservationType,
        refId: this.refId
      };
      axios.post('/reservation/register', {postParams})
              .then(response => {
                let responseCode = parseInt(response.data.code);
                if(responseCode !== 200){
                  alert(response.data.message);
                }
                else {

                  document.location.href = '/va-multumim';
                }
              })
              .catch(error => {
                console.log(error);
                alert('ERR: Ne cerem scuze! A aparut o eroare la procesare')
              })
    },
  },
  mounted(){

    this.pushRoom();

    this.reservationType = reservationType;
    this.refId = offerRefId;
    if(this.reservationType === 'acc'){

      this.showCheckIn = false;

      console.log(startDate);
      if (typeof startDate !== 'undefined'){

        this.form.departure_date = startDate;

      }
    }

    if(this.reservationType === 'request' && typeof startDate !== 'undefined'){

      this.form.departure_date = startDate;
    }

  }

}
</script>
<style>
  .form-control:focus {
    outline:none;
    border-color:transparent;
    box-shadow:none;
  }
  .reserv-send-request{
    margin-top:30px;
  }
  .vdp-datepicker * input{
    border-radius:5px;
    border: 1px solid #B1BFDB80;
    padding:5px;
    width:119px;
    margin-right:4px;
  }
  .vdp-datepicker * input:focus{
    outline:none;
    box-shadow:none;
    border: 1px solid #B1BFDB80;
  }
  .form-control:disabled, .form-control[readonly] {
    background-color: #ffffff !important;
  }
</style>

